import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type UpdateMobilityVehicleMutationVariables = Types.Exact<{
  id: Types.Scalars['bigint']['input'];
  set: Types.Mobility_Vehicles_Set_Input;
}>;


export type UpdateMobilityVehicleMutation = { __typename?: 'mutation_root', update_mobility_vehicles?: { __typename?: 'mobility_vehicles_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'mobility_vehicles', id: number, customer_id: number, make: string, model: string, year?: number | null, color?: string | null, license_plate?: string | null, vin?: string | null, capacity?: number | null, status: string, created_at: string, updated_at: string }> } | null };


export const UpdateMobilityVehicleDocument = gql`
    mutation UpdateMobilityVehicle($id: bigint!, $set: mobility_vehicles_set_input!) {
  update_mobility_vehicles(where: {id: {_eq: $id}}, _set: $set) {
    affected_rows
    returning {
      id
      customer_id
      make
      model
      year
      color
      license_plate
      vin
      capacity
      status
      created_at
      updated_at
    }
  }
}
    `;
export type UpdateMobilityVehicleMutationFn = Apollo.MutationFunction<UpdateMobilityVehicleMutation, UpdateMobilityVehicleMutationVariables>;

/**
 * __useUpdateMobilityVehicleMutation__
 *
 * To run a mutation, you first call `useUpdateMobilityVehicleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMobilityVehicleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMobilityVehicleMutation, { data, loading, error }] = useUpdateMobilityVehicleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      set: // value for 'set'
 *   },
 * });
 */
export function useUpdateMobilityVehicleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMobilityVehicleMutation, UpdateMobilityVehicleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMobilityVehicleMutation, UpdateMobilityVehicleMutationVariables>(UpdateMobilityVehicleDocument, options);
      }
export type UpdateMobilityVehicleMutationHookResult = ReturnType<typeof useUpdateMobilityVehicleMutation>;
export type UpdateMobilityVehicleMutationResult = Apollo.MutationResult<UpdateMobilityVehicleMutation>;
export type UpdateMobilityVehicleMutationOptions = Apollo.BaseMutationOptions<UpdateMobilityVehicleMutation, UpdateMobilityVehicleMutationVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/mobilityVehicles/queries/updateMobilityVehicle.mutation.gql}
 */
export async function updateMobilityVehicle(
  variables: UpdateMobilityVehicleMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<UpdateMobilityVehicleMutation['update_mobility_vehicles']>
export async function updateMobilityVehicle(
  variables: UpdateMobilityVehicleMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<UpdateMobilityVehicleMutation>
export async function updateMobilityVehicle(
  variables: UpdateMobilityVehicleMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<UpdateMobilityVehicleMutation['update_mobility_vehicles'] | UpdateMobilityVehicleMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<UpdateMobilityVehicleMutation>(
    UpdateMobilityVehicleDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.update_mobility_vehicles
}